import {MarketHelper} from "./MarketHelper";

export const purifyUrl = (url, parameters) => {
    if (!Array.isArray(parameters))
        parameters = [parameters];

    parameters.map((item, key) => {
        let param = url.slice(url.indexOf('{'), url.indexOf('}') + 1);
        url = url.replace(param, parameters[key])
    });

    return url;
};

export const purifyMessage = (cleanedString) => {
    let parameters = {
        "N": {
            "start": "[N]",
            "end": "[/N]"
        },
        "B": {
            "start": "[B]",
            "end": "[/B]"
        }
    }

    let maximumTry = 100
    while (1) {
        maximumTry = maximumTry - 1;

        if (cleanedString.match(/\[\/(.*?)\]/g) === null || maximumTry === 0)
            break;

        Object.keys(parameters).map((paramWithoutBracket, key) => {
            let startPosition = cleanedString.indexOf(parameters[paramWithoutBracket].start)
            let endPosition = cleanedString.indexOf(parameters[paramWithoutBracket].end)

            if(startPosition > 0 && endPosition > 0) {
                startPosition += parameters[paramWithoutBracket].start.length
                let string = cleanedString.slice(startPosition, endPosition)
                switch (paramWithoutBracket) {
                    case 'N':
                        cleanedString = cleanedString.replace(string, MarketHelper.localNumberFormat(string))
                        break;
                    case 'B':
                        cleanedString = cleanedString.replace(string, "<strong>" + string + "</strong>")
                        break;
                    default:
                        cleanedString = cleanedString.replace(string, MarketHelper.localNumberFormat(string))
                }

                let openStartPosition = cleanedString.indexOf(parameters[paramWithoutBracket].start)
                let openEndPosition = cleanedString.indexOf(parameters[paramWithoutBracket].start) + parameters[paramWithoutBracket].start.length
                cleanedString = cleanedString.replace(cleanedString.slice(openStartPosition, openEndPosition), '')

                let closeStartPosition = cleanedString.indexOf(parameters[paramWithoutBracket].end)
                let closeEndPosition = cleanedString.indexOf(parameters[paramWithoutBracket].end) + parameters[paramWithoutBracket].end.length
                cleanedString = cleanedString.replace(cleanedString.slice(closeStartPosition, closeEndPosition), '')
            }
        })
    }

    return {
        'withHtml': cleanedString,
        'withOutHtml': cleanedString.replace(/<[^>]+>/g, '')
    };
};


export const extractSearchParams = ({search}) => {
    if (search)
        return queryStringParser.parse(search);

    return {}
}